import { Translation } from "../hooks/useTranslations";

const de: Translation = {
  languageCode: "de",
  projects: {
    addTo: "Zum Projekt hinzufügen",
    all: "Alle Projekte",
    new: "Neues Projekt",
    singular: "Projekt",
    plural: "Projekte",
    my: "Meine Projekte",
    createNew: "Neues Projekt erstellen",
    infos: "Projektinformationen",
    delete: "Projekt löschen",
    removeShared: "Geteiltes Projekt entfernen",
    search: "Projekte suchen",
    shareWithUser: "Projekt mit Benutzer teilen",
    allowUserToEditSharedConfiguration: "Benutzer erlauben, die geteilte Konfiguration zu bearbeiten",
    allowUserToEditSharedProjectAndConfigurations:
      "Benutzer erlauben, das geteilte Projekt und die darin enthaltenen Konfigurationen zu bearbeiten",
    editSharings: "Freigaben bearbeiten",
    invitation: "Projekteinladung",
    invitations: "Projekteinladungen",
    invite: "Zum Projekt einladen",
    sharings: "Projektfreigaben",
    shared: "Geteiltes Projekt",
    sentAt: "Gesendet",
    resendInvite: "Einladung erneut senden",
    invitePage: {
      badge: "Projekteinladung zum Zugriff",
      loadingProjectDetails: "Projektdetails werden geladen...",
      collaborationLead:
        "hat Sie eingeladen, an diesem Projekt mitzuarbeiten und die freigegebenen Inhalte einzusehen.",
      projectName: "Projektname",
      inviteNoLongerAvailable:
        "Diese Einladung ist nicht mehr verfuegbar, weil sie bereits angenommen, abgelehnt oder abgebrochen wurde.",
      acceptSignedIn: "Wenn Sie diese Einladung annehmen, wird das Projekt sofort geoeffnet.",
      acceptSignedOut:
        "Wenn Sie diese Einladung annehmen, muessen Sie sich zuerst anmelden, bevor Sie Zugriff auf das Projekt erhalten.",
      inviteNotFound:
        "Diese Einladung wurde nicht gefunden. Sie wurde moeglicherweise entfernt oder der Link ist nicht korrekt.",
    },

    invitationStatus: {
      pending: "Ausstehend",
      active: "Aktiv",
      accepted: "Angenommen",
      rejected: "Abgelehnt",
      cancelled: "Abgebrochen",

      statusChanges: {
        rejected: "Einladung abgelehnt. Ihre E-Mail-Adresse wurde anonymisiert und aus diesem Projekt entfernt.",
        accept: "Einladung erfolgreich angenommen",
      },
    },

    questions: {
      delete: "Möchten Sie dieses Projekt wirklich löschen?",
      unshare: "Möchten Sie das Projekt wirklich für diesen Benutzer nicht mehr teilen?",
      cancelInvite: "Möchten Sie diese ausstehende Einladung wirklich stornieren?",
      removeShared:
        "Möchten Sie dieses Projekt wirklich aus Ihren geteilten Projekten entfernen? Sie verlieren den Zugriff darauf, und diese Aktion kann nicht rückgängig gemacht werden. Das Projekt und seine Konfigurationen bleiben davon unberührt.",
    },

    errors: {
      deleteProjectWithConfigurationsNotPossible:
        "Es ist nicht möglich, ein Projekt zu löschen, wenn Konfigurationen vorhanden sind.",
      deleteProjectWithDocumentsNotPossible:
        "Es ist nicht möglich, ein Projekt zu löschen, wenn Dokumente vorhanden sind.",
      notFound: "Projekt nicht gefunden.",
      sharingNotFound: "Freigabe nicht gefunden.",
      sharingAlreadyExists: "Dieses Projekt ist fuer diesen Benutzer bereits freigegeben.",
      inviteUpdateNotAllowed: "Sie sind nicht berechtigt, diese Einladung anzunehmen oder abzulehnen.",
      inviteAlreadyExists: "Fuer diesen Benutzer existiert bereits eine Einladung.",
      inviteAlreadyCancelled: "Diese Einladung wurde bereits abgebrochen.",
      inviteAlreadyAccepted: "Diese Einladung wurde bereits angenommen.",
      inviteAlreadyRejected: "Diese Einladung wurde bereits abgelehnt.",
      documentNotFound: "Dokument nicht gefunden.",
      missingDocumentName: "Dokumentenname fehlt.",
      documentAlreadyPresent: "Dokument bereits vorhanden.",
      missingProjectStatus: "Projektstatus fehlt.",
    },
  },

  configurations: {
    all: "Alle Konfigurationen",
    new: "Neue Konfiguration",
    plural: "Konfigurationen",
    create: "Konfiguration erstellen",
    createNew: "Neue Konfiguration erstellen",
    delete: "Konfiguration löschen",
    removeShared: "Geteilte Konfiguration entfernen",
    duplicate: "Konfiguration duplizieren",
    addToProject: "Zum Projekt hinzufügen",
    unlinkFromProject: "Vom Projekt trennen",
    my: "Meine Konfigurationen",
    search: "Konfigurationen suchen",
    reset: "Konfiguration zurücksetzen",

    questions: {
      delete: "Möchten Sie diese Konfiguration wirklich löschen?",
      reset: "Möchten Sie wirklich alle Daten der aktuellen Konfiguration zurücksetzen?",
      unlinkFromProject: "Möchten Sie diese Konfiguration wirklich von ihrem Projekt trennen?",
      removeShared:
        "Möchten Sie diese Konfiguration wirklich aus Ihren geteilten Konfigurationen entfernen? Sie verlieren den Zugriff darauf, und diese Aktion kann nicht rückgängig gemacht werden. Die Konfiguration bleibt davon unberührt.",
    },

    invitePage: {
      badge: "Konfigurationseinladung zum Zugriff",
      loadingConfigurationDetails: "Konfigurationsdetails werden geladen...",
      collaborationLead:
        "hat Sie eingeladen, an dieser Konfiguration mitzuarbeiten und die freigegebenen Inhalte einzusehen.",
      configurationName: "Konfigurationsname",
      inviteNoLongerAvailable:
        "Diese Einladung ist nicht mehr verfuegbar, weil sie bereits angenommen, abgelehnt oder abgebrochen wurde.",
      acceptSignedIn: "Wenn Sie diese Einladung annehmen, wird die Konfiguration sofort geoeffnet.",
      acceptSignedOut:
        "Wenn Sie diese Einladung annehmen, muessen Sie sich zuerst anmelden, bevor Sie Zugriff auf die Konfiguration erhalten.",
      inviteNotFound:
        "Diese Einladung wurde nicht gefunden. Sie wurde moeglicherweise entfernt oder der Link ist nicht korrekt.",
    },

    invitationStatus: {
      statusChanges: {
        rejected: "Einladung abgelehnt. Ihre E-Mail-Adresse wurde anonymisiert und aus dieser Konfiguration entfernt.",
        accept: "Einladung erfolgreich angenommen",
      },
    },

    errors: {
      notFound: "Konfiguration nicht gefunden.",
      missingNormative: "Normative Konfiguration fehlt.",
      missingSteelVersion: "Stahlversion der Konfiguration fehlt.",
      missingUpperSupportInstallationType: "Installationstyp der oberen Halterung fehlt.",
      missingUpperSupport: "Obere Halterung fehlt.",
      missingAbsorber: "Absorber fehlt.",
      missingSystemType: "Systemtyp der Konfiguration fehlt.",
      missingCable: "Kabel der Konfiguration fehlt.",
      alreadyLinkedToProject: "Diese Konfiguration ist bereits mit einem Projekt verknüpft.",
      notLinkedToProject: "Diese Konfiguration ist mit keinem Projekt verknüpft.",
    },
  },

  documents: {
    add: "Dokument hinzufügen",
    all: "Alle Dokumente",
    alreadyPresent: "Dokument bereits vorhanden.",
    plural: "Dokumente",
    delete: "Dokument löschen",
    search: "Dokumente suchen",

    questions: {
      delete: "Möchten Sie dieses Dokument wirklich löschen?",
      overwrite: "Möchten Sie das bereits vorhandene Dokument überschreiben?",
    },

    errors: {
      someCouldNotBeSaved: "Einige Dokumente konnten nicht gespeichert werden",
    },
  },

  systems: {
    all: "Alle Systeme",
    new: "Neues System",
    singular: "System",
    plural: "Systeme",
    delete: "System löschen",
    search: "Systeme suchen",
    our: "Unsere Systeme",

    questions: {
      delete: "Möchten Sie dieses System wirklich löschen?",
    },

    errors: {
      notFound: "System nicht gefunden.",
      inUseByConfiguration: "Das System wird noch von einer Konfiguration verwendet.",
    },
  },

  entityAccesses: {
    title: "Benutzerberechtigungen",
    add: "Benutzerberechtigung hinzufügen",
    accessColumn: "Zugriff",
    questions: {
      remove: "Möchten Sie den Zugriff dieses Benutzers wirklich entfernen?",
    },
    errors: {
      alreadyExists: "Dieser Benutzer hat bereits eine Berechtigung für dieses Element.",
    },
  },

  users: {
    add: "Benutzer hinzufügen",
    all: "Alle Benutzer",
    iam: {
      label: "IAM",
      missing: "Fehlt",
      valid: "Gültig",
    },
    invite: "Benutzer einladen",
    plural: "Benutzer",
    remove: "Benutzer entfernen",
    search: "Benutzer suchen",
    usersEmail: "Benutzer-E-Mail",
    usersName: "Benutzername",

    questions: {},

    errors: {
      notFound: "Benutzer nicht gefunden.",
      notFoundInAccounts: "Benutzer in accounts nicht gefunden.",
    },
  },

  items: {
    all: "Alle Elemente",
    singular: "Element",
    plural: "Elemente",
    createNew: "Neues Element erstellen",
    delete: "Element löschen",
    search: "Elemente suchen",
    list: "Elementliste",

    questions: {
      delete: "Möchten Sie dieses Element wirklich löschen?",
    },

    errors: {
      notFound: "Element nicht gefunden.",
      doesNotExist: "Artikel mit diesem Code existiert nicht.",
      missingCode: "Elementcode fehlt.",
    },
  },

  absorbers: {
    singular: "Absorber",
    plural: "Absorber",
    createNew: "Neuen Absorber erstellen",
    delete: "Absorber löschen",
    removeFromSystem: "Absorber vom System entfernen",
    edit: "Absorber bearbeiten",
    search: "Absorber suchen",

    questions: {
      delete: "Möchten Sie diesen Absorber wirklich löschen?",
      removeFromSystem: "Absorber vom System entfernen",
    },

    errors: {
      alreadyPresent: "Absorber bereits vorhanden.",
      notFound: "Absorber nicht gefunden.",
      noDefined: "Keine Absorber definiert.",
      inUseByConfiguration: "Absorber wird noch von einer Konfiguration verwendet.",
    },
  },

  cables: {
    createNew: "Neues Kabel erstellen",
    delete: "Kabel löschen",
    edit: "Kabel bearbeiten",
    search: "Kabel suchen",
    singular: "Kabel",
    plural: "Kabel",

    questions: {
      delete: "Möchten Sie dieses Kabel wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Kabel bereits vorhanden.",
      notFound: "Kabel nicht gefunden.",
      noDefined: "Keine Kabel definiert.",
      inUseByConfiguration: "Kabel wird noch von einer Konfiguration verwendet.",
    },
  },

  handles: {
    addItemAsVertigrip: "Element als Vertigrip-Griff hinzufügen",
    delete: "Griff löschen",
    edit: "Griff bearbeiten",
    singular: "Griff",
    plural: "Griffe",
    search: "Griffe suchen",
    noHandle: "Kein Griff",

    questions: {
      delete: "Möchten Sie diesen Griff wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Griff bereits vorhanden.",
      notFound: "Griff nicht gefunden.",
      inUseByConfiguration: "Griff wird noch von einer Konfiguration verwendet.",
      inUseByUpperExtension: "Griff wird noch von einer oberen Verlängerung verwendet.",
    },
  },

  intermediateElements: {
    createNew: "Neues Zwischenelement erstellen",
    delete: "Zwischenelement löschen",
    edit: "Zwischenelement bearbeiten",
    singular: "Zwischenelement",
    plural: "Zwischenelemente",
    search: "Zwischenelemente suchen",

    questions: {
      delete: "Möchten Sie dieses Zwischenelement wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Zwischenelement bereits vorhanden.",
      notFound: "Zwischenelement nicht gefunden.",
      inUseByConfiguration: "Zwischenelement wird noch von einer Konfiguration verwendet.",
    },
  },

  ladderReinforcements: {
    createNew: "Neue Leiterverstärkung erstellen",
    delete: "Leiterverstärkung löschen",
    edit: "Leiterverstärkung bearbeiten",
    singular: "Leiterverstärkung",
    plural: "Leiterverstärkungen",
    search: "Leiterverstärkungen suchen",
    noLadderReinforcement: "Keine Leiterverstärkung",

    questions: {
      delete: "Möchten Sie diese Leiterverstärkung wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Leiterverstärkung bereits vorhanden.",
      notFound: "Leiterverstärkung nicht gefunden.",
      inUseByConfiguration: "Leiterverstärkungen wird noch von einer Konfiguration verwendet.",
    },
  },

  wallMaterials: {
    createNew: "Neues Wandmaterial erstellen",
    delete: "Wandmaterial löschen",
    singular: "Wandmaterial",
    plural: "Wandmaterialien",
    search: "Wandmaterialien suchen",
    noWallMaterial: "Kein Wandmaterial",

    questions: {
      delete: "Möchten Sie dieses Wandmaterial wirklich löschen?",
    },

    errors: {
      notFound: "Wandmaterial nicht gefunden.",
      inUseByConfiguration: "Wandmaterial wird noch von einer Konfiguration verwendet.",
    },
  },

  wallMaterialFixings: {
    createNew: "Neue Befestigung erstellen",
    delete: "Befestigung löschen",
    singular: "Befestigung",
    plural: "Befestigungen",
    search: "Befestigungen suchen",

    questions: {
      delete: "Möchten Sie diese Befestigung wirklich löschen?",
    },

    errors: {
      notFound: "Befestigung nicht gefunden.",
      inUseByConfiguration: "Befestigung wird noch von einer Konfiguration verwendet.",
    },
  },

  wallMaterialFixingItems: {
    errors: {
      alreadyPresent: "Befestigung bereits vorhanden.",
    },
  },

  lowerElements: {
    createNew: "Neues Unterelement erstellen",
    delete: "Unterelement löschen",
    edit: "Unterelement bearbeiten",
    singular: "Unterelement",
    plural: "Unterelemente",
    search: "Unterelemente suchen",

    questions: {
      delete: "Möchten Sie dieses Unterelement wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Unterelement bereits vorhanden.",
      notFound: "Unterelement nicht gefunden.",
      inUseByConfiguration: "Unterelement wird noch von einer Konfiguration verwendet.",
    },
  },

  shuttles: {
    addItemAsVertigrip: "Element als Vertigrip-Shuttle hinzufügen",
    addItemAsPatrol: "Element als Patrol-Shuttle hinzufügen",
    delete: "Shuttle löschen",
    edit: "Shuttle bearbeiten",
    singular: "Shuttle",
    plural: "Shuttles",
    search: "Shuttles suchen",
    no: "Kein Shuttle",

    questions: {
      delete: "Möchten Sie dieses Shuttle wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Shuttle bereits vorhanden.",
      notFound: "Shuttle nicht gefunden.",
      inUseByConfiguration: "Shuttle wird noch von einer Konfiguration verwendet.",
    },
  },

  installationTypes: {
    plural: "Installationstypen",
    singular: "Installationstyp",
    search: "Installationstypen suchen",

    questions: {
      delete: "Möchten Sie diesen Installationstyp wirklich löschen?",
    },

    errors: {
      notFound: "Installationstyp nicht gefunden.",
      inUseByConfiguration: "Installationstyp wird noch von einer Konfiguration verwendet.",
      inUseByUpperExtension: "Installationstyp wird noch von einer oberen Verlängerung verwendet.",
      inUseByLowerElement: "Installationstyp wird noch von einem Unterelement verwendet.",
      inUseByIntermediateElement: "Installationstyp wird noch von einem Zwischenelement verwendet.",
      inUseByLadderReinforcement: "Installationstyp wird noch von einer Leiterverstärkung verwendet.",
    },
  },

  steelVersions: {
    createNew: "Neue Stahlversion erstellen",
    delete: "Stahlversion löschen",
    singular: "Stahlversion",
    plural: "Stahlversionen",
    search: "Stahlversionen suchen",

    questions: {
      delete: "Möchten Sie diese Stahlversion wirklich löschen?",
    },

    errors: {
      notFound: "Stahlversion nicht gefunden.",
      inUseByConfiguration: "Stahlversion wird noch von einer Konfiguration verwendet.",
      inUseByUpperExtension: "Stahlversion wird noch von einer oberen Verlängerung verwendet.",
      inUseByLowerElement: "Stahlversion wird noch von einem Unterelement verwendet.",
      inUseByIntermediateElement: "Stahlversion wird noch von einem Zwischenelement verwendet.",
      inUseByAsorber: "Stahlversion wird noch von einem Absorber verwendet.",
      inUseBySupport: "Stahlversion wird noch von einer Halterung verwendet.",
      inUseByCurvesIntermediate: "Stahlversion wird noch von einer/m Kurve/Zwischenelement verwendet.",
      inUseByTerminal: "Stahlversion wird noch von einem Endpunkt verwendet.",
      inUseByShuttle: "Stahlversion wird noch von einem Shuttle verwendet.",
      inUseByAnchorMapping: "Stahlversion wird noch von einer Anker-Zuordnung verwendet.",
      inUseByConfigurationAnchorPoint: "Stahlversion wird noch von einem Ankerpunkt verwendet.",
    },
    warnings: {
      deleteWarning: "Das Löschen dieser Daten wird andere Module/Konfigurationen beeinflussen.",
      editWarning: "Das Bearbeiten dieser Daten wird andere Module/Konfigurationen beeinflussen.",
    },
  },

  upperExtensions: {
    createNew: "Neue obere Verlängerung erstellen",
    delete: "Obere Verlängerung löschen",
    edit: "Obere Verlängerung bearbeiten",
    singular: "Obere Verlängerung",
    plural: "Obere Verlängerungen",
    search: "Obere Verlängerungen suchen",

    questions: {
      delete: "Möchten Sie diese obere Verlängerung wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Obere Verlängerung bereits vorhanden.",
      notFound: "Obere Verlängerung nicht gefunden.",
      noDefined: "Keine oberen Verlängerungen definiert.",
      inUseByConfiguration: "Obere Verlängerung wird noch von einer Konfiguration verwendet.",
    },
  },

  normatives: {
    createNew: "Neue Normative erstellen",
    delete: "Normative löschen",
    singular: "Normative",
    plural: "Normativen",
    search: "Normativen suchen",
    add: "Normativen hinzufügen",

    questions: {
      delete: "Möchten Sie diese Normative wirklich löschen?",
    },

    errors: {
      notFound: "Normative nicht gefunden.",
      noDefined: "Keine Normativen definiert.",
      inUseByConfiguration: "Normative wird noch von einer Konfiguration verwendet.",
    },
  },

  systemTypes: {
    singular: "Systemtyp",
    plural: "Systemtypen",
    search: "Systemtypen suchen",

    questions: {
      delete: "Möchten Sie diesen Systemtyp wirklich löschen?",
    },

    errors: {
      notFound: "Systemtyp nicht gefunden.",
      inUseByConfiguration: "Systemtyp wird noch von einer Konfiguration verwendet.",
      inUseByShuttle: "Systemtyp wird noch von einem Shuttle verwendet.",
      inUseByIntermediateElement: "Systemtyp wird noch von einem Zwischenelement verwendet.",
    },
  },

  texts: {
    singular: "Text",
    plural: "Texte",
    search: "Texte suchen",

    questions: {
      delete: "Möchten Sie diesen Text wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Text bereits vorhanden.",
      notFound: "Text nicht gefunden.",
      missingId: "Text Id fehlt.",
      missingValue: "Text Wert fehlt.",
    },
  },

  clients: {
    all: "Alle Clients",
    plural: "Clients",
    createNew: "Neuen Client erstellen",
    delete: "Client löschen",
    search: "Client suchen",

    questions: {
      delete: "Möchten Sie diesen Client wirklich löschen?",
    },

    errors: {
      notFound: "Client nicht gefunden.",
      insertNotAllowed: "Sie sind nicht berechtigt, einen neuen Client einzufügen.",
      readNotAllowed: "Sie sind nicht berechtigt, diesen Client zu lesen.",
      updateNotAllowed: "Sie sind nicht berechtigt, diesen Client zu aktualisieren.",
      deleteNotAllowed: "Sie sind nicht berechtigt, diesen Client zu löschen.",
    },
  },

  roles: {
    plural: "Rollen",
  },

  permissions: {
    plural: "Berechtigungen",
  },

  secrets: {
    plural: "Secrets",

    errors: {
      missingValue: "Secretwert fehlt.",
    },
  },

  clampings: {
    createNew: "Neue Klemmung erstellen",
    edit: "Klemmung bearbeiten",
    delete: "Klemmung löschen",
    singular: "Klemmung",
    plural: "Klemmungen",
    search: "Klemmungen suchen",
    questions: {
      delete: "Möchten Sie diese Klemmung wirklich löschen?",
    },
    errors: {
      notFound: "Klemmung nicht gefunden.",
      inUseByConfiguration: "Klemmung wird noch von einer Konfiguration verwendet.",
    },
  },
  elements: {
    createNew: "Neues Element erstellen",
    delete: "Element löschen",
    edit: "Element bearbeiten",
    singular: "Element",
    plural: "Elemente",
    search: "Elemente suchen",
    questions: {
      delete: "Möchten Sie dieses Element wirklich löschen?",
    },
    errors: {
      alreadyPresent: "Element bereits vorhanden",
      notFound: "Element nicht gefunden",
      inUseByConfiguration: "Element wird noch von einer Konfiguration verwendet",
    },
  },
  terminals: {
    createNew: "Neues Terminal erstellen",
    delete: "Terminal löschen",
    edit: "Terminal bearbeiten",
    singular: "Terminal",
    plural: "Terminals",
    search: "Terminals suchen",
    questions: {
      delete: "Möchten Sie dieses Terminal wirklich löschen?",
    },
    errors: {
      alreadyPresent: "Terminal bereits vorhanden",
      notFound: "Terminal nicht gefunden",
      inUseByConfiguration: "Terminal wird noch von einer Konfiguration verwendet",
    },
  },

  materials: {
    createNew: "Neues Material erstellen",
    delete: "Material löschen",
    singular: "Material",
    plural: "Materialien",
    search: "Material suchen",
    questions: {
      delete: "Möchten Sie dieses Material wirklich löschen?",
    },
  },

  roofTypes: {
    createNew: "Neuen Dachtyp erstellen",
    delete: "Dachtyp löschen",
    singular: "Dachtyp",
    plural: "Dachtypen",
    search: "Dachtypen suchen",
    questions: {
      delete: "Möchten Sie diesen Dachtyp wirklich löschen?",
    },
    errors: {
      pleaseSelectRoofType: "Bitte wählen Sie einen Dachtyp aus.",
    },
  },
  roofCategories: {
    createNew: "Neue Dachkategorie erstellen",
    delete: "Dachkategorie löschen",
    singular: "Dachkategorie",
    plural: "Dachkategorien",
    search: "Dachkategorien suchen",
    questions: {
      delete: "Möchten Sie diese Dachkategorie wirklich löschen?",
    },
    errors: {
      pleaseSelectRoofCategory: "Bitte wählen Sie eine Dachkategorie aus.",
      inUseByRoofType: "Die Kategorie wird noch von einem Dachtyp verwendet.",
    },
  },
  roofMaterials: {
    createNew: "Neues Dachmaterial erstellen",
    delete: "Dachmaterial löschen",
    singular: "Dachmaterial",
    plural: "Dachmaterialien",
    search: "Dachmaterialien suchen",
    questions: {
      delete: "Möchten Sie dieses Dachmaterial wirklich löschen?",
    },
  },

  roofSubstructures: {
    createNew: "Neue Dachunterkonstruktion erstellen",
    delete: "Dachunterkonstruktion löschen",
    singular: "Dachunterkonstruktion",
    single: "Dachunterkonstruktion",
    plural: "Dachunterkonstruktionen",
    search: "Dachunterkonstruktionen suchen",
    questions: {
      delete: "Möchten Sie diese Dachunterkonstruktion wirklich löschen?",
    },
  },
  sheetMaterials: {
    createNew: "Neues Blechmaterial erstellen",
    delete: "Blechmaterial löschen",
    edit: "Blechmaterial bearbeiten",
    singular: "Blechmaterial",
    plural: "Blechmaterialien",
    search: "Blechmaterialien suchen",
    questions: {
      delete: "Möchten Sie dieses Blechmaterial wirklich löschen?",
    },
  },
  patrolSystems: {
    createNew: "Neues Patrol-System erstellen",
    delete: "Patrol-System löschen",
    singular: "Patrol-System",
    plural: "Patrol-Systeme",
    search: "Patrol-Systeme suchen",
    questions: {
      delete: "Möchten Sie dieses Patrol-System wirklich löschen?",
    },
  },
  patrolSystemMappings: {
    createNew: "Neue Patrol-System-Zuordnung erstellen",
    delete: "Patrol-System-Zuordnung löschen",
    edit: "Patrol-System-Zuordnung bearbeiten",
    singular: "Patrol-System-Zuordnung",
    plural: "Patrol-System-Zuordnungen",
    search: "Patrol-System-Zuordnungen suchen",
    questions: {
      delete: "Möchten Sie diese Patrol-System-Zuordnung wirklich löschen?",
    },
  },
  systemNormatives: {
    createNew: "Neue Systemnorm erstellen",
    delete: "Systemnorm löschen",
    edit: "Systemnorm bearbeiten",
    singular: "Systemnorm",
    plural: "Systemnormen",
    search: "Systemnormen suchen",
    questions: {
      delete: "Möchten Sie diese Systemnorm wirklich löschen?",
    },

    errors: {
      normativeAlreadyPresent: "Die ausgewählte Vorschrift ist bereits dem System zugeordnet.",
    },
  },
  uprightSpanMappings: {
    createNew: "Neue Pfosten-Spannweiten-Zuordnung erstellen",
    delete: "Pfosten-Spannweiten-Zuordnung löschen",
    edit: "Pfosten-Spannweiten-Zuordnung bearbeiten",
    singular: "Pfosten-Spannweiten-Zuordnung",
    plural: "Pfosten-Spannweiten-Zuordnungen",
    search: "Pfosten-Spannweiten-Zuordnungen suchen",
    questions: {
      delete: "Möchten Sie diese Pfosten-Spannweiten-Zuordnung wirklich löschen?",
    },
    errors: {
      alreadyPresent: "Pfosten-Spannweiten-Zuordnung bereits vorhanden",
      updateNotAllowed: "Sie sind nicht berechtigt, diese Pfosten-Spannweiten-Zuordnung zu aktualisieren.",
    },
  },
  uprightMappings: {
    createNew: "Neue Pfosten-Zuordnung erstellen",
    delete: "Pfosten-Zuordnung löschen",
    edit: "Pfosten-Zuordnung bearbeiten",
    singular: "Pfosten-Zuordnung",
    plural: "Pfosten-Zuordnungen",
    search: "Pfosten-Zuordnungen suchen",
    questions: {
      delete: "Möchten Sie diese Pfosten-Zuordnung wirklich löschen?",
    },
    errors: {
      alreadyPresent: "Pfosten-Zuordnung bereits vorhanden",
    },
  },
  patrolAnchorMappings: {
    createNew: "Neue Patrol-Anker-Zuordnung erstellen",
    delete: "Patrol-Anker-Zuordnung löschen",
    edit: "Patrol-Anker-Zuordnung bearbeiten",
    singular: "Patrol-Anker-Zuordnung",
    plural: "Patrol-Anker-Zuordnungen",
    search: "Patrol-Anker-Zuordnungen suchen",
    questions: {
      delete: "Möchten Sie diese Patrol-Anker-Zuordnung wirklich löschen?",
    },
  },
  membranes: {
    createNew: "Neue Membrane erstellen",
    delete: "Membrane löschen",
    singular: "Membrane",
    plural: "Membranen",
    search: "Membranen suchen",
    questions: {
      delete: "Möchten Sie diese Membrane wirklich löschen?",
    },
    single: "Membrane",
  },
  patrolSupports: {
    createNew: "Neue Unterstützung erstellen",
    delete: "Unterstützung löschen",
    edit: "Unterstützung bearbeiten",
    singular: "Unterstützung",
    plural: "Unterstützungen",
    search: "Unterstützungen suchen",
    questions: {
      delete: "Möchten Sie diese Unterstützung wirklich löschen?",
    },
  },
  itemNormativeExclusions: {
    add: "Ausgeschlossenes Element hinzufügen",
    createNew: "Neue Normausschluss für Element erstellen",
    delete: "Normausschluss für Element löschen",
    edit: "Normausschluss für Element bearbeiten",
    singular: "Normausschluss für Element",
    plural: "Normausschlüsse für Element",
    search: "Normausschlüsse für Element suchen",
    questions: {
      remove: "Möchten Sie dieses ausgeschlossene Element wirklich entfernen?",
    },
    errors: {
      notFound: "Normausschluss für Element nicht gefunden.",
    },
  },
  supportExtensions: {
    createNew: "Neue Support-Erweiterung erstellen",
    delete: "Support-Erweiterung löschen",
    edit: "Support-Erweiterung bearbeiten",
    singular: "Support-Erweiterung",
    plural: "Support-Erweiterungen",
    search: "Support-Erweiterungen suchen",
    questions: {
      delete: "Möchten Sie diese Support-Erweiterung wirklich löschen?",
    },
  },
  supportExtras: {
    createNew: "Neue Support-Extra erstellen",
    delete: "Support-Extra löschen",
    edit: "Support-Extra bearbeiten",
    singular: "Support-Extra",
    plural: "Support-Extras",
    search: "Support-Extras suchen",
    questions: {
      delete: "Möchten Sie dieses Support-Extra wirklich löschen?",
    },
  },
  supportOptionals: {
    createNew: "Neue optionale Support erstellen",
    delete: "Optionale Support löschen",
    edit: "Optionale Support bearbeiten",
    singular: "Optionale Support",
    plural: "Optionale Supports",
    search: "Optionale Supports suchen",
    questions: {
      delete: "Möchten Sie diese optionale Support wirklich löschen?",
    },
  },
  patrolCurveIntermediates: {
    singular: "Kurve/Zwischenstück",
    plural: "Kurven/Zwischenstücke",
    createNew: "Neue Kurve/Zwischenstück erstellen",
    delete: "Kurve/Zwischenstück löschen",
    edit: "Kurve/Zwischenstück bearbeiten",
    search: "Kurven/Zwischenstücke suchen",
    questions: {
      delete: "Möchten Sie diese Kurve/Zwischenstück wirklich löschen?",
    },
  },
  normativeVersions: {
    singular: "Normative Version",
    plural: "Normative Versionen",
    add: "Normative Version hinzufügen",
    createNew: "Neue normative Version erstellen",
    errors: {
      atLeastOneSystemRequired: "Mindestens ein System wird benötigt.",
    },
  },
  anchorPoints: {
    addNew: "Neue Ankerpunkte hinzufügen",
    singular: "Ankerpunkt",
    plural: "Ankerpunkte",
    delete: "Ankerpunkt löschen",
    hide: "Ankerpunkte ausblenden",
    show: "Ankerpunkte anzeigen",
    questions: {
      delete: "Möchten Sie den ausgewählten Ankerpunkt wirklich löschen?",
    },
  },
  accessPoints: {
    addNew: "Neue Zugangspunkte hinzufügen",
    singular: "Zugangspunkt",
    delete: "Zugangspunkt löschen",
    questions: {
      delete: "Möchten Sie den ausgewählten Zugangspunkt wirklich löschen?",
    },
  },
  lifeLines: {
    draw: "Lebenslinie zeichnen",
    singular: "Lebenslinie",
    plural: "Lebenslinien",
    delete: "Lebenslinie löschen",
    hide: "Lebenslinien ausblenden",
    show: "Lebenslinien anzeigen",
    questions: {
      deleteEdge: "Möchten Sie das ausgewählte Segment wirklich löschen?",
      deleteNode: "Möchten Sie den ausgewählten Schnittpunkt wirklich löschen?",
    },
    errors: {
      creatingCrossIntersectionsNotAllowed: "Das Erstellen einer Kreuzung mit vier Punkten ist nicht erlaubt.",
      loopsNotAllowed: "Das aktuell ausgewählte System erlaubt keine Schleifen.",
      intersectionsNotAllowed: "Das aktuell ausgewählte System erlaubt keine 3-Wege-Kreuzungen.",
      systemDoesNotAllowMoreThanXCorners: (maxCorners: number) =>
        `Das aktuell ausgewählte System erlaubt nicht mehr als ${maxCorners} Ecken`,
    },
  },

  substructures: {
    createNew: "Neue Unterstruktur erstellen",
    delete: "Unterstruktur löschen",
    singular: "Unterstruktur",
    plural: "Unterstrukturen",
    single: "Unterstruktur",
    search: "Unterstrukturen suchen",
    edit: "Unterstruktur bearbeiten",

    questions: {
      delete: "Möchten Sie diese Unterstruktur wirklich löschen?",
    },
  },

  bases: {
    createNew: "Neue Basis erstellen",
    delete: "Basis löschen",
    singular: "Basis",
    plural: "Basen",
    search: "Basen suchen",
    edit: "Basis bearbeiten",
    add: "Basis hinzufügen",

    questions: {
      delete: "Möchten Sie diese Basis wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Basis bereits vorhanden",
      notFound: "Basis nicht gefunden",
    },
  },

  ballasts: {
    createNew: "Neuen Ballast erstellen",
    delete: "Ballast löschen",
    singular: "Ballast",
    plural: "Ballaste",
    search: "Ballaste suchen",
    edit: "Ballast bearbeiten",
    add: "Ballast hinzufügen",

    questions: {
      delete: "Möchten Sie diesen Ballast wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Ballast bereits vorhanden",
      notFound: "Ballast nicht gefunden",
    },
  },

  ballastTypes: {
    createNew: "Neuen Ballasttyp erstellen",
    delete: "Ballasttyp löschen",
    singular: "Ballasttyp",
    plural: "Ballasttypen",
    search: "Ballasttypen suchen",
    edit: "Ballasttyp bearbeiten",

    questions: {
      delete: "Möchten Sie diesen Ballasttyp wirklich löschen?",
    },

    errors: {
      missingName: "Name des Ballasttyps fehlt",
      notFound: "Ballasttyp nicht gefunden",
    },
  },

  uprights: {
    createNew: "Neuen Ständer erstellen",
    delete: "Ständer löschen",
    singular: "Ständer",
    plural: "Ständer",
    search: "Ständer suchen",
    edit: "Ständer bearbeiten",
    add: "Ständer hinzufügen",

    questions: {
      delete: "Möchten Sie diesen Ständer wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Ständer bereits vorhanden",
      notFound: "Ständer nicht gefunden",
    },
  },

  uprightTypes: {
    createNew: "Neuen Ständertyp erstellen",
    delete: "Ständertyp löschen",
    singular: "Ständertyp",
    plural: "Ständertypen",
    search: "Ständertypen suchen",
    edit: "Ständertyp bearbeiten",
    add: "Ständertyp hinzufügen",

    questions: {
      delete: "Möchten Sie diesen Ständertyp wirklich löschen?",
    },

    errors: {
      missingName: "Name des Ständertyps ist erforderlich",
      notFound: "Ständertyp nicht gefunden",
      inUseByUprights: "Ständertyp wird noch von einem oder mehreren Ständern verwendet",
    },
  },

  guardrailCompositions: {
    createNew: "Neue Geländerzusammensetzung erstellen",
    delete: "Geländerzusammensetzung löschen",
    singular: "Geländerzusammensetzung",
    plural: "Geländerzusammensetzungen",
    search: "Geländerzusammensetzungen suchen",
    edit: "Geländerzusammensetzung bearbeiten",
    add: "Geländerzusammensetzung hinzufügen",

    questions: {
      delete: "Möchten Sie diese Geländerzusammensetzung wirklich löschen?",
    },

    errors: {
      missingName: "Name der Geländerzusammensetzung fehlt",
      notFound: "Geländerzusammensetzung nicht gefunden",
    },
  },

  rails: {
    createNew: "Neue Schiene erstellen",
    delete: "Schiene löschen",
    singular: "Schiene",
    plural: "Schienen",
    search: "Schienen suchen",
    edit: "Schiene bearbeiten",
    add: "Schiene hinzufügen",

    questions: {
      delete: "Möchten Sie diese Schiene wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Schiene bereits vorhanden",
      notFound: "Schiene nicht gefunden",
    },
  },

  toeBoards: {
    createNew: "Neue Fußleiste erstellen",
    delete: "Fußleiste löschen",
    singular: "Fußleiste",
    plural: "Fußleisten",
    search: "Fußleisten suchen",
    edit: "Fußleiste bearbeiten",
    add: "Fußleiste hinzufügen",

    questions: {
      delete: "Möchten Sie diese Fußleiste wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Fußleiste bereits vorhanden",
      notFound: "Fußleiste nicht gefunden",
    },
  },

  toeBoardExtras: {
    createNew: "Neue Zusatz-Fußleiste erstellen",
    delete: "Zusatz-Fußleiste löschen",
    singular: "Zusatz-Fußleiste",
    plural: "Zusatz-Fußleisten",
    search: "Zusatz-Fußleisten suchen",
    edit: "Zusatz-Fußleiste bearbeiten",
    add: "Zusatz-Fußleiste hinzufügen",

    questions: {
      delete: "Möchten Sie diese Zusatz-Fußleiste wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Zusatz-Fußleiste bereits vorhanden",
      notFound: "Zusatz-Fußleiste nicht gefunden",
    },
  },

  uprightCaps: {
    createNew: "Neue Ständerkappe erstellen",
    delete: "Ständerkappe löschen",
    singular: "Ständerkappe",
    plural: "Ständerkappen",
    search: "Ständerkappen suchen",
    edit: "Ständerkappe bearbeiten",
    add: "Ständerkappe hinzufügen",

    questions: {
      delete: "Möchten Sie diese Ständerkappe wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Ständerkappe bereits vorhanden",
      notFound: "Ständerkappe nicht gefunden",
    },
  },

  railCaps: {
    createNew: "Neue Schienenkappe erstellen",
    delete: "Schienenkappe löschen",
    singular: "Schienenkappe",
    plural: "Schienenkappen",
    search: "Schienenkappen suchen",
    edit: "Schienenkappe bearbeiten",
    add: "Schienenkappe hinzufügen",

    questions: {
      delete: "Möchten Sie diese Schienenkappe wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Schienenkappe bereits vorhanden",
      notFound: "Schienenkappe nicht gefunden",
    },
  },

  railWallFixings: {
    createNew: "Neue Wandbefestigung für die Schiene erstellen",
    delete: "Wandbefestigung für die Schiene löschen",
    singular: "Wandbefestigung für die Schiene",
    plural: "Wandbefestigungen für die Schiene",
    search: "Wandbefestigungen für die Schiene suchen",
    edit: "Wandbefestigung für die Schiene bearbeiten",
    add: "Wandbefestigung für die Schiene hinzufügen",

    questions: {
      delete: "Möchten Sie diese Wandbefestigung für die Schiene wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Wandbefestigung für die Schiene bereits vorhanden",
      notFound: "Wandbefestigung für die Schiene nicht gefunden",
    },
  },

  railCorners: {
    createNew: "Neue Schienenecke erstellen",
    delete: "Schienenecke löschen",
    singular: "Schienenecke",
    plural: "Schienenecken",
    search: "Schienenecken suchen",
    edit: "Schienenecke bearbeiten",
    add: "Schienenecke hinzufügen",

    questions: {
      delete: "Möchten Sie diese Schienenecke wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Schienenecke bereits vorhanden",
      notFound: "Schienenecke nicht gefunden",
    },
  },

  gates: {
    createNew: "Neues Tor erstellen",
    delete: "Tor löschen",
    singular: "Tor",
    plural: "Tore",
    search: "Tore suchen",
    edit: "Tor bearbeiten",
    add: "Tor hinzufügen",

    questions: {
      delete: "Möchten Sie dieses Tor wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Tor bereits vorhanden",
      notFound: "Tor nicht gefunden",
    },
  },

  waterproofKits: {
    createNew: "Neues Abdichtungsset erstellen",
    delete: "Abdichtungsset löschen",
    singular: "Abdichtungsset",
    plural: "Abdichtungssets",
    search: "Abdichtungssets suchen",
    edit: "Abdichtungsset bearbeiten",
    add: "Abdichtungsset hinzufügen",

    questions: {
      delete: "Möchten Sie dieses Abdichtungsset wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Abdichtungsset bereits vorhanden",
      notFound: "Abdichtungsset nicht gefunden",
    },
  },

  fastenings: {
    singular: "Befestigung",
  },

  fasteningChoices: {
    createNew: "Neue Befestigungskombination erstellen",
    delete: "Befestigungskombination löschen",
    edit: "Befestigungskombination bearbeiten",
    singular: "Befestigungskombination",
    plural: "Befestigungskombinationen",
    search: "Befestigungskombinationen suchen",
    combination: "Kombination",
    factorPerUpright: "Faktor pro Pfosten",

    questions: {
      delete: "Möchten Sie diese Befestigungskombination wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Befestigungskombination bereits vorhanden",
      duplicateFastening: "Doppelte Befestigung ausgewählt",
      notFound: "Befestigungskombination nicht gefunden",
    },
  },

  membraneProtections: {
    createNew: "Neue Schutzmembran erstellen",
    delete: "Schutzmembran löschen",
    singular: "Schutzmembran",
    plural: "Schutzmembranen",
    search: "Schutzmembranen suchen",
    edit: "Schutzmembran bearbeiten",
    add: "Schutzmembran hinzufügen",

    questions: {
      delete: "Möchten Sie diese Schutzmembran wirklich löschen?",
    },

    errors: {
      alreadyPresent: "Schutzmembran bereits vorhanden",
      notFound: "Schutzmembran nicht gefunden",
    },
  },

  workMethods: {
    singular: "Arbeitsmethode",
    plural: "Arbeitsmethoden",
    deleteLabel: "Arbeitsmethode",
    new: "Neue Arbeitsmethode",
    edit: "Arbeitsmethode bearbeiten",
    delete: "Arbeitsmethode löschen",
    search: "Arbeitsmethoden suchen",
  },
  supports: {
    singular: "Support",
    plural: "Supports",
    deleteLabel: "Support",
    new: "Neuer Support",
    edit: "Support bearbeiten",
    delete: "Support löschen",
    search: "Supports suchen",
  },
  labelLanguages: {
    singular: "Etikettensprache",
    plural: "Etikettensprachen",
    deleteLabel: "Etikettensprache",
    new: "Neue Etikettensprache",
    edit: "Etikettensprache bearbeiten",
    delete: "Etikettensprache löschen",
    search: "Etikettensprachen suchen",
  },
  towers: {
    singular: "Turm",
    plural: "Türme",
    deleteLabel: "Turm",
    new: "Neuer Turm",
    edit: "Turm bearbeiten",
    delete: "Turm löschen",
    search: "Türme suchen",
  },
  trolleys: {
    singular: "Laufwagen",
    plural: "Laufwagen",
    deleteLabel: "Laufwagen",
    new: "Neuer Laufwagen",
    edit: "Laufwagen bearbeiten",
    delete: "Laufwagen löschen",
    search: "Laufwagen suchen",
  },
  railCurves: {
    singular: "Schienenkurve",
    plural: "Schienenkurven",
    deleteLabel: "Schienenkurve",
    new: "Neue Schienenkurve",
    edit: "Schienenkurve bearbeiten",
    delete: "Schienenkurve löschen",
    search: "Schienenkurven suchen",
  },
  railJunctions: {
    singular: "Schienenverbindung",
    plural: "Schienenverbindungen",
    deleteLabel: "Schienenverbindung",
    new: "Neue Schienenverbindung",
    edit: "Schienenverbindung bearbeiten",
    delete: "Schienenverbindung löschen",
    search: "Schienenverbindungen suchen",
  },
  railTerminals: {
    singular: "Schienenendstück",
    plural: "Schienenendstücke",
    deleteLabel: "Schienenendstück",
    new: "Neues Schienenendstück",
    edit: "Schienenendstück bearbeiten",
    delete: "Schienenendstück löschen",
    search: "Schienenendstücke suchen",
  },
  screws: {
    singular: "Schraube",
    plural: "Schrauben",
    deleteLabel: "Schraube",
    new: "Neue Schraube",
    edit: "Schraube bearbeiten",
    delete: "Schraube löschen",
    search: "Schrauben suchen",
  },
  tools: {
    singular: "Werkzeug",
    plural: "Werkzeuge",
    deleteLabel: "Werkzeug",
    new: "Neues Werkzeug",
    edit: "Werkzeug bearbeiten",
    delete: "Werkzeug löschen",
    search: "Werkzeuge suchen",
  },
  fasteningOptions: {
    singular: "Befestigungsoption",
    plural: "Befestigungsoptionen",
    deleteLabel: "Befestigungsoption",
    new: "Neue Befestigungsoption",
    edit: "Befestigungsoption bearbeiten",
    delete: "Befestigungsoption löschen",
    search: "Befestigungsoptionen suchen",
  },
  fasteningOptionItems: {
    singular: "Befestigungsoptions-Element",
    plural: "Befestigungsoptions-Elemente",
    deleteLabel: "Befestigungsoptions-Element",
    new: "Neues Befestigungsoptions-Element",
    edit: "Befestigungsoptions-Element bearbeiten",
    delete: "Befestigungsoptions-Element löschen",
    search: "Befestigungsoptions-Elemente suchen",
  },
  itemExtras: {
    singular: "Zusatzelement",
    plural: "Extras",
    deleteLabel: "Zusatzelement",
    new: "Neues Zusatzelement",
    edit: "Zusatzelement bearbeiten",
    delete: "Zusatzelement löschen",
    search: "Extras suchen",
  },
  supportItems: {
    singular: "Support-Element",
    plural: "Support-Elemente",
    deleteLabel: "Support-Element",
    new: "Neues Support-Element",
    edit: "Support-Element bearbeiten",
    delete: "Support-Element löschen",
    search: "Support-Elemente suchen",
  },
  systemSupportOptions: {
    singular: "System-Support-Option",
    plural: "System-Support-Optionen",
    deleteLabel: "System-Support-Option",
    new: "Neue System-Support-Option",
    edit: "System-Support-Option bearbeiten",
    delete: "System-Support-Option löschen",
    search: "System-Support-Optionen suchen",
  },

  common: {
    active: "Aktiv",
    accept: "Akzeptieren",
    add: "Hinzufügen",
    addPoints: "Punkte hinzufügen",
    addNewItem: "Neues Element hinzufügen",
    address: "Adresse",
    administration: "Administration",
    allow: "Erlauben",
    deny: "Verweigern",
    shared: "Geteilt",
    canEdit: "Kann bearbeiten",
    alreadyPresent: "Bereits vorhanden",
    general: "Allgemein",
    itemDependencies: "Elementabhängigkeiten",
    millimeters: " mm",
    deduction: "Abzug",
    nominalAngle: "Nominalwinkel",
    deflection: "Ablenkung",
    horizontalDeduction: "Horizontaler Abzug",
    internalDeduction: "Innenabzug",
    externalDeduction: "Außenabzug",
    doubleTerminal: "Doppelterminal",
    doubleTerminalVisible: "Doppelterminal sichtbar",
    factorPerFasteningPoint: "Faktor pro Befestigungspunkt",
    factorPerLabel: "Faktor pro Etikett",
    fasteningOption: "Befestigungsoption",
    fasteningPoints: "Befestigungspunkte",
    fasteningPointsPerSupport: "Befestigungspunkte pro Support",
    floor: "Boden",
    overhead: "Überkopf",
    wall: "Wand",
    none: "Keiner",
    required: "Erforderlich",
    horizontal: "Horizontal",
    vertical: "Vertikal",
    terminalTypeClosed: "Geschlossen",
    terminalTypeOpen: "Offen",
    jointHoleTemplateVisible: "Lochschablone für Verbindung sichtbar",
    jointTemplate: "Verbindungsschablone",
    junctions: "Verbindungen",
    junctionsRequired: "Verbindungen erforderlich",
    mountingContext: "Montagekontext",
    plane: "Ebene",
    quantity: "Menge",
    quantityPerItem: "Menge pro Artikel",
    quantityPerSupport: "Menge pro Support",
    supportsRequired: "Supports erforderlich",
    hrailSupport: "Support",
    systemHeader: (title: string) => `System: ${title}`,
    terminalType: "Terminaltyp",
    tower: "Turm",
    workMethod: "Arbeitsmethode",
    fasteningOptionHeader: (title: string) => `Befestigungsoption: ${title}`,
    deleteEntityQuestion: (entity: string, label: string) => `${entity} "${label}" löschen?`,
    angle: "Winkel",
    angles: "Winkel",
    archived: "Archiviert",
    atLeastOneItemNeeded: "Mindestens ein Element wird benötigt.",
    author: "Autor",
    automaticSync: "Automatische Synchronisierung",
    baseOrientation: "Grundausrichtung",
    cornerClassification: "Eckenklassifizierung",
    back: "Zurück",
    baseHeight: "Grundhöhe",
    bottomClamp: "Untere Klemme",
    bottomItems: "Untere Elemente",
    breadcrumb: "Navigationspfad",
    canBeCustom: "Kann angepasst werden",
    canBeMultiple: "Kann mehrfach sein",
    cancel: "Abbrechen",
    categories: "Kategorien",
    city: "Stadt",
    clamped: "Geklemmt",
    clampThickness: "Klemmdicke",
    close: "Schließen",
    code: "Code",
    codeItem: "Artikelnummer",
    codeExtraItem: "Zusatzartikelnummer",
    company: "Firma",
    componentMaterial: "Komponentenmaterial",
    componentMaterials: "Komponentenmaterialien",
    components: "Komponenten",
    confirmed: "Bestätigt",
    contactPerson: "Kontaktperson",
    contactPersonWarning:
      "Die Eingabe dieser Daten ist freiwillig und liegt in der vollen Verantwortung des Benutzers. Es wird nicht empfohlen, Daten einzugeben, die Personen identifizieren oder identifizierbar machen.",
    coordinates: "Koordinaten",
    copy: "Kopieren",
    corners: "Ecken",
    country: "Land",
    corrugationSpan: "Wellenlänge",
    curb: "Bordstein",
    curbHeight: "Bordsteinhöhe",
    curbDepth: "Bordsteintiefe",
    curbHeightBelowMinimum: (value: number) => `Die Mindestbordsteinhöhe für diese Auswahl beträgt ${value} mm`,
    curbDepthBelowBaseHeight: (value: number) =>
      `Die Bordsteintiefe muss mindestens ${value} mm betragen, um die ausgewählte Basis aufzunehmen`,
    create: "Erstellen",
    created: "Erstellt",
    createNew: "Neu erstellen",
    currentRoofDoesNotAllowAnchorPoints: "Die aktuelle Dachkonfiguration ist nicht für einzelne Ankerpunkte geeignet.",
    curve: "Kurve",
    curved: "Gebogen",
    curves: "Kurven",
    dataHasBeenSavedSuccessfully: "Daten wurden erfolgreich gespeichert.",
    date: "Datum",
    decrease: (value: number) => `${value} verringern`,
    download: "Herunterladen",
    delete: "Löschen",
    description: "Beschreibung",
    descriptionLong: "Lange Beschreibung",
    descriptionShort: "Kurze Beschreibung",
    details: "Details",
    diameter: "Durchmesser",
    distance: "Abstand",
    dragAndDropOrUploadAnImage: "Bild ziehen und ablegen oder klicken um eines hochladen",
    dropIt: "Hochladen!",
    duplicate: "Duplizieren",
    writePermissions: "Schreibrechte",
    editor: "Editor",
    email: "E-Mail",
    error: "Fehler",
    errorLoadingData: "Fehler beim Laden der Daten",
    excel: "Excel",
    failed: "Fehlgeschlagen",
    fieldCannotBeEmpty: "Das Feld darf nicht leer sein.",
    fieldContainsInvalidValueInsertBiggerOne: "Das Feld enthält einen ungültigen Wert, geben Sie einen größeren ein.",
    fieldContainsInvalidValueInsertSmallerOne: "Das Feld enthält einen ungültigen Wert, geben Sie einen kleineren ein.",
    fieldValueInvalidFormat: "Der Wert hat ein ungültiges Format.",
    fieldInvalidValue: "Das Feld enthält einen ungültigen Wert.",
    fixed: "Fest",
    forbidden: "Nicht erlaubt",
    generalData: "Allgemeine Daten",
    genericError: "Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut.",
    guardrailComposition: "Geländerzusammensetzung",
    heightToReach: "Höhe erreichen",
    hidden: "Hidden",
    home: "Startseite",
    increase: (value: number) => `${value} Erhöhen`,
    installed: "Installiert",
    intermediateSupport: "Zwischenhalterung",
    isBallastRequired: "Ist Ballast erforderlich",
    isFasteningVisible: "Ist die Befestigung sichtbar",
    isGateVisible: "Ist das Tor sichtbar",
    isHighWindVisible: "Hohe Windlast sichtbar",
    isIntermediateBarRequired: "Ist Zwischenholm erforderlich",
    isSubstructureRequired: "Ist eine Unterkonstruktion erforderlich",
    isSubstructureDetailsRequired: "Details der Unterkonstruktion erforderlich",
    isPerimeterSplitRequired: "Aufteilung des Umfangs erforderlich",
    isCornerOrientationRequired: "Ausrichtung der Ecken erforderlich",
    isReclinableUpright: "Ist umklappbar",
    isCurbVisible: "Bordstein sichtbar",
    isCurbDepthVisible: "Bordsteintiefe sichtbar",
    isReinforced: "Ist verstärkt",
    isToeBoardRequired: "Ist Fußleiste erforderlich",
    isVertical: "Ist vertikal",
    isVerticalBaseTypeRequired: "Ist ein vertikaler Basistyp erforderlich",
    isWaterproofKitVisible: "Ist das Abdichtungsset sichtbar",
    isWedgeVisible: "Ist der Keil sichtbar",
    isVisible: "Sichtbar",
    visibility: "Sichtbarkeit",
    rothoblaasUsers: "Rothoblaas-Benutzer",
    externalUsers: "Externe Benutzer",
    everyOne: "Alle",
    ladderExitDifference: "Differenz Leiterausgang",
    translations: "Übersetzungen",
    appLanguage: "App-Sprache",
    languages: {
      singular: "Sprache",
      plural: "Sprachen",
      arabic: "Arabisch",
      czech: "Tschechisch",
      danish: "Dänisch",
      german: "Deutsch",
      greek: "Griechisch",
      english: "Englisch",
      spanish: "Spanisch",
      estonian: "Estnisch",
      finnish: "Finnisch",
      french: "Französisch",
      croatian: "Kroatisch",
      hungarian: "Ungarisch",
      icelandic: "Isländisch",
      italian: "Italienisch",
      japanese: "Japanisch",
      lithuanian: "Litauisch",
      latvian: "Lettisch",
      dutch: "Niederländisch",
      norwegian: "Norwegisch",
      polish: "Polnisch",
      portugese: "Portugiesisch",
      russian: "Russisch",
      slovak: "Slowakisch",
      slovenian: "Slowenisch",
      swedish: "Schwedisch",
      turkish: "Türkisch",
      chinese: "Chinesisch",
      korean: "Koreanisch",
    },
    firstName: "Vorname",
    lastAccess: "Letzter Zugriff",
    lastModified: "Zuletzt geändert",
    lastName: "Nachname",
    lastSync: "Letzte Synchronisierung",
    left: "Links",
    loading: "Lädt...",
    login: "Login",
    location: "Anmelden",
    logout: "Abmelden",
    lowerSupport: "Unterhalterung",
    lowerHoleDiameter: "Unterer Lochdurchmesser",
    minimumConfigurableQuantity: "Mindestkonfigurierbare Menge",
    minimumOrderQuantity: "Mindestbestellmenge",
    minOrderQuantity: "Min. Bestellm.",
    myArea: "Mein Bereich",
    myProfile: "Mein Profil",
    name: "Name",
    next: "Weiter",
    never: "nie",
    newConfigurationName: "Neuer Name Konfiguration",
    nextNRows: (n: number) => `Nächste ${n} Zeilen`,
    no: "Nein",
    noItemsFound: "Keine Elemente gefunden",
    notFound: "Nicht gefunden",
    nrBallastIntermediate: "Anz. Zwischenballaste",
    nrBallastTerminal: "Anz. Endballaste",
    nrIntermediatesAndSpan: "Nr. Zwischenstücke und Spannweite",
    nrRivets: "Anz. Nieten",
    nrOfFixingItemsRequired: "Anzahl der benötigten Befestigungselemente (pro Wandmaterial)",
    offer: "Angebot",
    ok: "Ok",
    onlyImagesAreAllowed: "Nur Bilder sind erlaubt.",
    open: "Öffnen",
    optional: "optional",
    order: "Reihenfolge",
    overwrite: "Überschreiben",
    previousNRows: (n: number) => `Vorherige ${n} Zeilen`,
    print: "Drucken",
    privacyPolicy: "Datenschutzrichtlinie",
    qty: "Menge",
    reject: "Ablehnen",
    removable: "Abnehmbar",
    rename: "Umbenennen",
    reclining: "Umklappbar",
    remove: "Entfernen",
    removeImage: "Bild entfernen",
    reinforcedRailRequired: "Verstärkte Schiene erforderlich",
    reset: "Zurücksetzen",
    resetToDefault: "Auf Standard zurücksetzen",
    resourceNotFound: "Die angeforderte Ressource wurde nicht gefunden.",
    right: "Rechts",
    save: "Speichern",
    saved: "Gespeichert",
    draft: "Entwurf",
    search: "Suchen",
    select: "Auswählen",
    selectProject: "Projekt auswählen",
    selectProjectFirst: "Zuerst Projekt auswählen",
    selectProjectInwhichCreateCopy: "Wählen Sie das Projekt aus, in dem die Kopie erstellt werden soll",
    sessionExpired: "Sitzung abgelaufen",
    sessionExpiredText: "Bitte melden Sie sich erneut an, um die App weiter zu verwenden.",
    settings: "Einstellungen",
    status: "Status",
    straight: "Gerade",
    sync: "Synchronisieren",
    targa: "Targa",
    testEnvironment: "Testumgebung",
    toBeInstalled: "Zu installieren",
    toInspect: "Zu prüfen",
    uploadedAt: "Hochgeladen",
    uploadedBy: "Hochgeladen von",
    upperSupport: "Obere Halterung",
    upperHoleDiameter: "Oberer Lochdurchmesser",
    value: "Wert",
    visible: "Sichtbar",
    yes: "Ja",
    youAreNotAllowed: "Sie sind nicht berechtigt auf diese Ressource zuzugreifen.",
    youCannotMixUpSubstructureHeightSizeAndThickness:
      "Sie können die Unterkonstruktion Höhe, Größe und Metallplattendicke nicht vermischen.",
    youCannotMixUpSubstructureMaxSpanAndMaxInsulationThickness:
      "Sie können die maximale Spannweite der Unterkonstruktion und die maximale Dämmstoffdicke nicht vermischen.",

    excludedItems: "Ausgeschlossene Elemente",
    extensions: "Erweiterungen",
    extras: "Extras",
    flatRoofCompatible: "Flachdach-kompatibel",
    hasHips: "Hat Grate",
    height: "Höhe",
    image: "Bild",
    hipLength: "Gratlänge",
    hipsSpan: "Gratspannweite",
    hipsSpanRequired: "Gratspannweite erforderlich",
    insulationThickness: "Dämmstoffdicke",
    insulationThicknessRequired: "Dämmstoffdicke erforderlich",
    intermediates: "Zwischenstücke",
    isFlat: "Ist flach",
    isLifeLine: "Ist Lebenslinie",
    length: "Länge",
    loop: "Schleife",
    mappings: "Zuordnungen",
    max: "Max",
    maxInsulationThickness: "Max. Dämmstoffdicke",
    maxPitch: "Max. Neigung",
    maxSpan: "Max. Spannweite",
    maxThickness: "Max. Dicke",
    maxUsers: "Max. Benutzer",
    min: "Min",
    minMetalPlateThickness: "Min. Metallplattendicke",
    minSubstructureHeight: "Min. Unterkonstruktionshöhe",
    minSubstructureSize: "Min. Unterkonstruktionsgröße",
    minThickness: "Min. Dicke",
    minCurbHeight: "Min. Bordsteinhöhe",
    minHeight: "Min. Höhe",
    minSpan: "Min. Spannweite",
    minValue: "Min. Wert",
    minWidth: "Min. Breite",
    notLoop: "Keine Schleife",
    notRightAngle: "Kein rechter Winkel",
    nrOfShuttlesForLifeLines: "Anzahl der Shuttle für Lebenslinien",
    nrOfShuttlesRequestted: "Anzahl der angeforderten Shuttle",
    pitch: "Neigung",
    perimeter: "Umfang",
    closedPerimeter: "Geschlossener Umfang",
    perimeterLength: "Gesamtumfangslänge",
    perimeterLengthParallel: "Länge parallel zur Wellung",
    perimeterLengthPerpendicular: "Länge senkrecht zur Wellung",
    cornerCountTotal: "Gesamtanzahl der Ecken",
    cornerCountInternal: "Anzahl der Innenecken",
    cornerCountExternal: "Anzahl der Außenecken",
    parallel: "Parallel",
    perpendicular: "Senkrecht",
    internal: "Innen",
    external: "Außen",
    pleaseSpecifyAHeight: "Bitte geben Sie eine Höhe an",
    pleaseSpecifyAWidth: "Bitte geben Sie eine Breite an",
    pleaseSpecifyHeightAndWidth: (height: number, width: number, unit: string) =>
      `Bitte geben Sie (Höhe)x(Breite) an: ${height}x${width} ${unit}`,
    rightAngle: "Rechter Winkel",
    roof: "Dach",
    roofInfo: "Dach-Info",
    roofs: "Dächer",
    roofWeight: "Dachgewicht",
    roofWeightRequired: "Dachgewicht erforderlich",
    seamHeight: "Naht-Höhe",
    seamHeightRequired: "Naht-Höhe erforderlich",
    seamsSpan: "Naht-Spannweite",
    seamsSpanRequired: "Naht-Spannweite erforderlich",
    sheetMaterialRequired: "Blechmaterial erforderlich",
    span: "Spannweite",
    stepHeightRequired: "Stufenhöhe erforderlich",
    substructureHeight: "Unterkonstruktionshöhe",
    substructures: "Unterkonstruktionen",
    substructureSize: "Unterkonstruktionsgröße",
    supports: "Halterungen",
    supportHeight: "Halterungshöhe",
    supportMaterialRequired: "Halterungsmaterial erforderlich",
    supportSelection: "Halterungsauswahl",
    type: "Typ",
    types: "Typen",
    caps: "Kappen",
    useOnlyAnchorPoints: "Nur Ankerpunkte verwenden",
    wallFixings: "Wandbefestigungen",
    waveSpan: "Wellenspannweite",
    waveSpanRequired: "Wellenspannweite erforderlich",
    width: "Breite",
    lifeLineAnchors: "Lebenslinie/Ankerpunkte",
    absorberAllowsMaxNUsers: (value: number) => `Absorber erlaubt maximal ${value} Benutzer.`,
    metalPlateThickness: "Metallplatten-Dicke",
    supportIntermediateElement: "Zwischenelement unterstützen",
    supportIntermediateElements: "Zwischenelemente unterstützen",
    supportTerminalCurve: "Terminal/Kurve unterstützen",
    extraItem: "Zusatzelement",
    forLoop: "Für Schleife",
    forNotLoop: "Für Nicht-Schleife",
    invitationHasBeenSentSuccessfully: "Einladung wurde erfolgreich gesendet.",
    invite: "Einladen",
    invitePage: {
      fallbackAuthorName: "ein Teammitglied",
      invitedBy: "Eingeladen von",
      invitationSentTo: "Einladung gesendet an",
      description: "Beschreibung",
      notAvailable: "Nicht verfuegbar",
      acceptAction: "Einladung annehmen",
      rejectAction: "Einladung ablehnen",
      notFoundTitle: "Einladung nicht gefunden",
    },
    isAnchorPoint: "Ist Ankerpunkt",
    stepHeight: "Stufenhöhe",
    cookiePolicy: "Cookie-Richtlinie",
    default: "Standard",
    defaultPitch: "Standard-Neigung",
    degrees: "Grad",
    draw: "Zeichnen",
    edit: "Bearbeiten",
    editCurve: "Kurve bearbeiten",
    editPatrolComponent: "Patrol-Komponente bearbeiten",
    editTerminal: "Terminal bearbeiten",
    erease: "Löschen",
    factor: "Faktor",
    finish: "Fertig",
    forTerminalsAndCurves: "Für Terminals und Kurven",
    forIntermediates: "Für Zwischenstücke",
    globalSettings: "Globale Einstellungen",
    help: "Hilfe",
    hide: "Ausblenden",
    hipsSpans: "Gratspannweiten",
    includeSelectedComponent: "Ausgewählte Komponente einbeziehen",
    includeTarga: "Targa einbeziehen",
    intermediate: "Zwischenstück",
    intersectionPoint: "Schnittpunkt",
    isClampable: "Ist klemmbar",
    isSubstructureIndependent: "Ist unabhängig von der Unterkonstruktion",
    lifeLine: "Lebenslinie",
    lifeLinePlusAnchorPoint: "Lebenslinie + Ankerpunkt",
    lifeLinesAndAnchorPointsHaveBeenFound_message:
      "Es wurden Lebenslinien und Ankerpunkte gefunden. Um die Dacheinstellungen zu bearbeiten, müssen Sie diese Daten löschen. Klicken Sie auf 'Löschen', um sie zu entfernen und das Formular freizugeben",
    lifeLineSegment: "Lebenslinien-Segment",
    maxAngle: "Max. Winkel",
    maxCornersPerLifeline: "Max. Ecken pro Lebenslinie",
    maxHeight: "Max. Höhe",
    maxSeamsSpan: "Max. Naht-Spannweite",
    maxSpanBetweenCurveAndIntermediate: "Max. Abstand zwischen Kurve und Zwischenstücken",
    maxSpanBetweenIntermediate: "Max. Abstand zwischen Zwischenstücken",
    minAngle: "Min. Winkel",
    minSpanBetweenSupports: "Min. Abstand zwischen Halterungen",
    minPitch: "Min. Neigung",
    noAdditionalPost: "Kein zusätzlicher Pfosten",
    normativeDetails: "Normative Details",
    onlyAnchorPoint: "Nur Ankerpunkt",
    onlyFor: "Nur für",
    onlyLifeLine: "Nur Lebenslinie",
    optionals: "Optionale",
    permissionToEdit: "Berechtigung zum Bearbeiten",
    pitchMinMaxDefault: "Neigung (min/max/standard)",
    pleaseSpecifyAMaxHeight: "Bitte geben Sie eine maximale Höhe an",
    pleaseSpecifyAMinHeight: "Bitte geben Sie eine minimale Höhe an",
    pleaseSpecifyAValueBetween: (min: number, max: number | null, unit: string | null) =>
      (max ? `Bitte geben Sie einen Wert zwischen ${min} und ${max}` : `Bitte geben Sie einen Wert größer als ${min}`) +
      (unit ? ` ${unit}` : "").trim(),
    searchIntermediatedCurves: "Zwischenstücke/Kurven suchen",
    selectedComponent: "Ausgewählte Komponente",
    show: "Anzeigen",
    spans: "Spannweiten",
    splitLifeLineHere: "Lebenslinie hier teilen",
    stepHeightRange: "Stufenhöhenbereich",
    support: "Halterung",
    supportCurve: "Kurven-Halterung",
    supportTerminal: "Terminal-Halterung",
    supportTerminalAndCurve: "Terminal- und Kurven-Halterung",
    terminal: "Terminal",
    terminal_plus_intermediate: "Terminal+Zwischenstück",
    terminalAndCurve: "Terminal und Kurve",
    terminalCurves: "Terminals/Kurven",
    terminalCurveAndIntermediate: "Terminal, Kurve und Zwischenstück",
    termsAndConditions: "Geschäftsbedingungen",
    theMaximumAllowedValueIs: (value: number) => `Der maximal erlaubte Wert ist ${value}°`,
    theMinimumAllowedValueIs: (value: number) => `Der minimal erlaubte Wert ist ${value}°`,
    topClamp: "Obere Klemme",
    topExtraItem: "Oberes Zusatzelement",
    topItem: "Oberes Element",
    unlock: "Entsperren",
    unshare: "Freigabe aufheben",
    update: "Aktualisieren",
    versions: "Versionen",
    warningThisEditCouldAffectOtherSystemsAsWell: "Warnung: Diese Bearbeitung könnte auch andere Systeme beeinflussen",
    defaultSupports: "Standars Halterungen",
    from: "Von",
    meters: "Meter",
    supportRequired: "Halterung erforderlich",
    supportsHeight: "Halterungshöhe",
    terminal_plus_terminal: "Terminal-Terminal",
    theMaximulAllowedLifeLineLengthExceeds: (
      meters: number,
      curves: number,
      maxLength: number,
      allowedLength: number,
    ) =>
      `Die Lebenslinie des ausgewählten Segments hat eine Länge von ${meters} Metern. Aufgrund der ${curves} Kurven wird die maximal erlaubte Länge von ${maxLength} Metern auf ${allowedLength} reduziert. Bitte teilen Sie sie auf.`,
    theMinAngleOfCurveForTheSystemIs_degrees: (degrees: number) =>
      `Das aktuell ausgewählte System erlaubt keine Kurven enger als ${degrees}°`,
    theMinAngleIfIntermediateAndTerminalforTheSystemIs_degrees: (degrees: number) =>
      `Das aktuell ausgewählte System mit einer Kreuzung (Endpunkt+Zwischenpunkt) erfordert eine fast gerade Linie (mindestens ${degrees}°)`,
    theSystemRequiresAMinSpanOfXMeters: (minSpan: number) =>
      `Das System erfordert eine minimale Spannweite von ${minSpan} Metern`,
    to: "Bis",
  },
};

export default de;
